import styled from 'styled-components';

import { Dropdown } from '../';

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;
